// extracted by mini-css-extract-plugin
export default {"container":"Selection_container__MsW8d","content":"Selection_content__FRHv4","banner":"Selection_banner__ssbCS","loading":"Selection_loading__6gy8G"};